// extracted by mini-css-extract-plugin
module.exports = {"issues":"issues-module__issues___4v_ef","content":"issues-module__content___dZdj3","button":"issues-module__button___GrrGu","bigbutton":"issues-module__bigbutton___2xnQl"};